import {useDispatch, useSelector} from "react-redux";
import {FIELD_LIST_CAMPAIGN_BANNER_AVO_STORIES_2, FIELD_LIST_CAMPAIGN_BANNER_GENERAL_AVO_STORIES_2} from "../../../utils/input-field-list-static-page";
import {setAvoStories2CampaignBannerDetail, setAvoStories2ErrorMessage} from "../../../reducers/avo-stories-2.reducer";
import {convertErrorMessage, randomCode} from "../../../utils/general-variable";
import {cloneDeep} from "lodash";
import {useEffect} from "react";
import FormItemComponent from "../../../components/static-page/form-item.component";
import ItemCampaignBanner from "./item-campaign-banner";
import {useFetch} from "../../../services/useFetch";
import {API} from "../../../services/api";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../../reducers/tools.reducer";

const CampaignBanner = () => {
    const dispatch = useDispatch()
    const {campaignBannerDetail, avoStories2ErrorMessage} = useSelector(state => state.avoStories2Reducer)
    const {fetching: getCampaignBanner} = useFetch(API.AVO_STORIES_2_GET_CAMPAIGN_BANNER)
    const {fetching: updateCampaignBanner, isLoading} = useFetch(API.AVO_STORIES_2_UPDATE_CAMPAIGN_BANNER)
    const itemList = [...campaignBannerDetail.item_list]
    let fieldListGeneral = FIELD_LIST_CAMPAIGN_BANNER_GENERAL_AVO_STORIES_2
    let fieldList = FIELD_LIST_CAMPAIGN_BANNER_AVO_STORIES_2
    let showCampaignBanner = {
        label: 'Campaign Banner',
        key: 'show_campaign_banner',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setAvoStories2CampaignBannerDetail({[key]: value}))
    }

    const addItemHandler = () => {
        itemList.push({
            id: randomCode(5, 1, 'campaign_banner').toString(),
            title: null,
            description: null,
            desktop_image: null,
            mobile_image: null
        })
        dispatch(setAvoStories2CampaignBannerDetail({item_list: itemList}))
    }

    const itemListConstruct = () => {
        const itemListCopy = cloneDeep(campaignBannerDetail.item_list)
        const result = itemListCopy?.map((item, index) => {
            if(!Number(item.id)) delete item.id
            item.sequence = index
            return item
        })
        return result
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        const dataItemList = itemListConstruct()
        const dataCampaignBanner = {...campaignBannerDetail, item_list: dataItemList}
        updateCampaignBanner(dataCampaignBanner).then(response => {
            dispatch(setAvoStories2ErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Campaign Banner Updated'))
            dispatch(setAvoStories2CampaignBannerDetail({...response?.data, delete_item: []}))
        }).catch(err => {
            dispatch(setAvoStories2ErrorMessage(convertErrorMessage(err)))
        })
    }

    useEffect(() => {
        getCampaignBanner().then(response => {
            if (response?.data?.item_list?.length > 0) {
                dispatch(setAvoStories2CampaignBannerDetail({...response?.data, delete_item: []}))
            } else {
                const data = response?.data
                delete data?.item_list
                dispatch(setAvoStories2CampaignBannerDetail({...data, delete_item: []}))
            }
        })

        return () => {
            dispatch(setAvoStories2ErrorMessage({}))
        }
    }, [])

    return (
        <FormItemComponent
            data={campaignBannerDetail}
            switchToggleField={showCampaignBanner}
            fieldListGeneral={fieldListGeneral}
            itemList={itemList}
            content={(index) => <ItemCampaignBanner fieldList={fieldList} index={index}/>}
            onChange={onChange}
            setDataList={setAvoStories2CampaignBannerDetail}
            deleteList={campaignBannerDetail?.delete_item}
            objectDeleteName={'delete_item'}
            addItemHandler={addItemHandler}
            onSubmitHandler={onSubmitHandler}
            errorMessage={avoStories2ErrorMessage}
            isLoading={isLoading}
        />
    )
}

export default CampaignBanner
